export default __webpack_public_path__ + "static/mainSectionImageBig-a0da69f966a8dd4ee5e6e01efd723134.svg";